import { Add, BeachAccess, Delete, InfoOutlined } from "@mui/icons-material";
import { Card, IconButton, Stack } from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { HolidaysContext, RequestsContext } from "../contexts";
import { useDictionary, useUser } from "../hooks";
import { addMonthsToDate, renderHeader } from "../utilities";
import HeaderCollapse from "./HeaderCollapse";
import RequestsGeneralPanel from "./RequestsGeneralPanel";


const HolydaysPanel = () => {
  const {
    state: { holidays },
    setHolidays,
    addHoliday,
    deleteHoliday,
  } = useContext(HolidaysContext);
  const {user} = useUser();
  const dictionary = useDictionary();

  useEffect(() => {
    setHolidays(user.id);
  }, []);

  return (
    <Card>
      <HeaderCollapse
        color={"requests"}
        title={dictionary["dashboard"]["holidaysRequests"]}
        notificationCount={holidays?.length}
        Icon={BeachAccess}
        actions={
          <Stack direction="row" justifyContent="center" alignItems="center">
            <IconButton
            id="add-holidays-request"
              onClick={() => addHoliday(user.id, dictionary)}
              sx={{ color: (theme) => theme.palette.common.white }}
              size="small"
            >
              <Add fontSize="small" />
            </IconButton>
            <IconButton
              sx={{ color: (theme) => theme.palette.common.white }}
              size="small"
              component={Link}
              to="/approvers"
            >
              <InfoOutlined fontSize="small" />
            </IconButton>
          </Stack>
        }
      />
      <RequestsGeneralPanel
        requests={holidays}
        columns={[
          {
            headerName: dictionary["from"],
            renderHeader: renderHeader(dictionary["from"]),
            field: "datefrom",
            flex: 2,
            sortable: false,
            renderCell: ({ value }) =>
              moment(new Date(value)).format("DD/MM/YYYY"),
          },
          {
            headerName: dictionary["to"],
            renderHeader: renderHeader(dictionary["to"]),
            field: "dateto",
            sortable: false,
            flex: 2,
            renderCell: ({ value }) =>
              moment(new Date(value)).format("DD/MM/YYYY"),
          },
          {
            headerName: dictionary["holidays"]["days"],
            renderHeader: renderHeader(dictionary["holidays"]["days"]),
            flex: 1,
            sortable: false,
            field: "days",
          },
          {
            headerName: dictionary["actions"],
            renderHeader: renderHeader(dictionary["actions"]),
            sortable: false,
            flex: 1,
            field: "",
            renderCell: ({ row }) => {
              if (row.status !== "DELETED" && row.status !== "CANCELLED") {
                return (
                  <Stack direction="row">
                    <IconButton
                    id="delete-holidays-request"
                      onClick={() => {
                        deleteHoliday(row, dictionary, setHolidays, user.id);
                      }}
                      aria-label="delete-request"
                      color="error"
                      size="small"
                    >
                      <Delete fontSize="inherit" />
                    </IconButton>
                  </Stack>
                );
              } else {
                return <></>;
              }
            },
          },
        ]}
      />
    </Card>
  );
};

export default HolydaysPanel;
